import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import { CONTENT_DISTRIBUTION_API, CONTENT_DISTRIBUTION_DELIVERY, CONTENT_DISTRIBUTION_RESPONSE_TYPE, ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../constant/constant';
import * as API from "../../framework/API/api"
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { utility } from '../utility/utilityProvider';
import MyMultiSelect from '../../components/MyMultiSelect';
import { OttAssetCollection } from './OttAssetCollection';
import { OttEditForm } from './OttEditForm';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ContentDistributionForm from './ContentDistributionForm';
import ContentDistributionDeliveryForm from './ContentDistributionDeliveryForm';
import ToastNotification from '../../components/ToastNotification';

const ContentDistributionEditForm = ({ item, cancelEdit, refresh }) => {
    const lang = useTranslation();

    const blankDataItem = {
        ...item,
        Name: item?.copy ? "Copy of " + item?.Name : item?.Name ?? "",
        Aggregator: item?.Aggregator ?? [],
        ValidFrom: item?.ValidFrom ? utility.convertMilisecondsToDateString(item?.ValidFrom) : "",
        ValidTo: item?.ValidTo ? utility.convertMilisecondsToDateString(item?.ValidTo) : "",
        TBA: item?.TBA ?? false,
        ContentDistributionApiIds: item?.ContentDistributionApiIds?.length > 0
            ? item.ContentDistributionApiIds.map((x) => ({
                _id: x,
                Description: utility.getKeyByValue(CONTENT_DISTRIBUTION_API, x)
            }))
            : [],
        ResponseType: item?.ResponseType ? { _id: item?.ResponseType, Description: utility.getKeyByValue(CONTENT_DISTRIBUTION_RESPONSE_TYPE, item?.ResponseType) } : { _id: CONTENT_DISTRIBUTION_RESPONSE_TYPE.JSON, Description: utility.getKeyByValue(CONTENT_DISTRIBUTION_RESPONSE_TYPE, CONTENT_DISTRIBUTION_RESPONSE_TYPE.JSON) },
        Distribution: {
            ContentDistributionApi: item?.Distribution?.ContentDistributionApi ? { _id: item.Distribution.ContentDistributionApi, Description: utility.getKeyByValue(CONTENT_DISTRIBUTION_API, item.Distribution.ContentDistributionApi) } : {},
            BaseUrl: item?.Distribution?.BaseUrl ?? "",
            curlData: item?.Distribution?.curlData ?? "",
            response: item?.Distribution?.response ?? ""
        }
    };
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [aggregators, setAggregators] = useState([]);
    const [accessKey, setAccessKey] = useState(item?.AccessKey ?? "");
    const [tabNumber, setTabNumber] = useState("1");
    const [contentDistributionApis, setContentDistributionApis] = useState([]);
    const [responseTypes, setResponseTypes] = useState([]);
    const [deliveryDataItem, setDeliveryDataItem] = useState(() => {

        const deliveryId = typeof item?.Delivery === "string" ? item?.Delivery : item?.Delivery?._id ?? item?.Delivery?.Delivery?._id ?? CONTENT_DISTRIBUTION_DELIVERY.S3;

        return {
            ...item,
            accessKeyId: item?.Delivery?.accessKeyId ?? "",
            secretAccessKey: item?.Delivery?.secretAccessKey ?? "",
            region: item?.Delivery?.region ?? "",
            bucketName: item?.Delivery?.bucketName ?? "",
            CdnUrl: item?.Delivery?.CdnUrl ?? "",
            host: item?.Delivery?.host ?? "",
            username: item?.Delivery?.username ?? "",
            password: item?.Delivery?.password ?? "",
            remotePath: item?.Delivery?.remotePath ?? "",
            Delivery: { _id: deliveryId, Description: utility.getKeyByValue(CONTENT_DISTRIBUTION_DELIVERY, deliveryId) },
        };
    });

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const aggregatorsRes = await API.getDataLookup(ENTITYNAME.Ott_Aggregator, { sort: { Description: 1 } });
        setAggregators(aggregatorsRes.data);
        const contentDistributionApiRes = Object.keys(CONTENT_DISTRIBUTION_API).map((x) => {
            return {
                _id: CONTENT_DISTRIBUTION_API[x],
                Description: x
            }
        })
        setContentDistributionApis(contentDistributionApiRes);
        const responseTypeRes = Object.keys(CONTENT_DISTRIBUTION_RESPONSE_TYPE).map((x) => {
            return {
                _id: CONTENT_DISTRIBUTION_RESPONSE_TYPE[x],
                Description: x
            }
        })
        setResponseTypes(responseTypeRes);
    };

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else if (e.target.name === 'TBA') {
            setDataItem({ ...dataItem, TBA: !dataItem.TBA });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const generateAccessKey = () => {
        const array = new Uint8Array(32);
        window.crypto.getRandomValues(array);
        const base64 = btoa(String.fromCharCode(...array)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        setAccessKey(base64);
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(accessKey);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.copied_to_clipboard_message });
    };

    const isValid = () => {

        if (!dataItem.Name || dataItem.Name.trim() === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if (!dataItem.Aggregator || Object.keys(dataItem.Aggregator).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_aggregator_error_message });
            return false;
        }
        if (!dataItem.ValidFrom || dataItem.ValidFrom === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_from_error_message });
            return false;
        }
        if (!dataItem.TBA && (!dataItem.ValidTo || dataItem.ValidTo === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_to_error_message });
            return false;
        }
        if (!accessKey || accessKey === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_generate_access_key_error_message });
            return false;
        }
        if (tabNumber == "3" && deliveryDataItem?.Delivery?._id === CONTENT_DISTRIBUTION_DELIVERY.S3) {
            if (deliveryDataItem.accessKeyId == undefined || deliveryDataItem.accessKeyId == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_access_keyid_error_message });
                return false;
            }
            if (deliveryDataItem.secretAccessKey == undefined || deliveryDataItem.secretAccessKey == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_secret_access_key_error_message });
                return false;
            }
            if (deliveryDataItem.region == undefined || deliveryDataItem.region == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_region_error_message });
                return false;
            }
            if (deliveryDataItem.bucketName == undefined || deliveryDataItem.bucketName == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_bucket_name_error_message });
                return false;
            }
            if (deliveryDataItem.CdnUrl == undefined || deliveryDataItem.CdnUrl == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_cdn_url_error_message });
                return false
            }

        } else if (tabNumber == "3" && deliveryDataItem?.Delivery?._id === CONTENT_DISTRIBUTION_DELIVERY.FTP) {
            if (deliveryDataItem.host == undefined || deliveryDataItem.host == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_ftp_host_error_message });
                return false;
            }
            if (deliveryDataItem.username == undefined || deliveryDataItem.username == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_ftp_username_error_message });
                return false;
            }
            if (deliveryDataItem.password == undefined || deliveryDataItem.password == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_ftp_password_error_message });
                return false;
            }
            if (deliveryDataItem.remotePath == undefined || deliveryDataItem.remotePath == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_ftp_remote_path_error_message });
                return false;
            }
        }
        return true;
    };

    const handleSubmit = async () => {


        let formattedDelivery = { Delivery: deliveryDataItem?.Delivery };

        if (deliveryDataItem?.Delivery?._id === CONTENT_DISTRIBUTION_DELIVERY.S3) {
            formattedDelivery = {
                accessKeyId: deliveryDataItem?.accessKeyId ?? "",
                secretAccessKey: deliveryDataItem?.secretAccessKey ?? "",
                region: deliveryDataItem?.region ?? "",
                bucketName: deliveryDataItem?.bucketName ?? "",
                CdnUrl: deliveryDataItem?.CdnUrl ?? "",
                Delivery: deliveryDataItem?.Delivery
            };
        } else if (deliveryDataItem?.Delivery?._id === CONTENT_DISTRIBUTION_DELIVERY.FTP) {
            formattedDelivery = {
                host: deliveryDataItem?.host ?? "",
                username: deliveryDataItem?.username ?? "",
                password: deliveryDataItem?.password ?? "",
                remotePath: deliveryDataItem?.remotePath ?? "",
                Delivery: deliveryDataItem?.Delivery
            };
        }
        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Name: dataItem?.Name,
            Aggregator: dataItem?.Aggregator?.length > 0 ? dataItem?.Aggregator?.map((x) => { return { _id: x?._id, Description: x?.Description } }) : [],
            ValidFrom: dataItem?.ValidFrom ? utility.convertStringDatetoMilliseconds(dataItem?.ValidFrom) : null,
            ValidTo: dataItem?.ValidTo ? utility.convertStringDatetoMilliseconds(dataItem?.ValidTo) : null,
            TBA: dataItem?.TBA ?? false,
            AccessKey: accessKey,
            ContentDistributionApiIds: dataItem?.ContentDistributionApiIds?.length > 0 ? dataItem?.ContentDistributionApiIds?.map(x => x?._id) : [],
            ResponseType: dataItem?.ResponseType?._id,
            Archive: dataItem?.Archive ?? false,
            Delivery: formattedDelivery,
            Distribution: {
                ContentDistributionApi: dataItem?.Distribution?.ContentDistributionApi?._id,
                BaseUrl: dataItem?.Distribution?.BaseUrl ?? "",
                curlData: dataItem?.Distribution?.curlData ?? "",
                response: dataItem?.Distribution?.response ?? ""
            },
            checkDuplicate: true,
            query: [["Name", "=", dataItem.Name]]
        };

        console.log(saveData)
        const res = await API.saveData(ENTITYNAME.ContentDistribution, saveData);
        if (res.success) {
            const logData = {
                event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT,
                module: MODULE.CONTENT_DISTRIBUTION,
                data: res.data,
                message: res.message
            };
            API.SaveLogs(logData);
            cancelEdit();
            refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.ContentDistribution);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    return (
        <BossDialog
            title={item?.Name ?? lang.content_distribution_dialog_header}
            onClose={cancelEdit}
            width='68%'
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={cancelEdit} showTitle={false} />

            <div className='row mt-2'>
                <div className='col-12'>
                    <div className='row mt-2'>
                        <div className='col-6'>
                            <label>{lang.name_label} *</label>
                            <input
                                name="Name"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Name}
                            />
                        </div>
                        <div className="col-6">
                            <label>{lang.aggregator_label} *</label>
                            <MyMultiSelect
                                style={{ backgroundColor: "white" }}
                                className="form-control form-control-sm"
                                data={aggregators}
                                name="Aggregator"
                                textField="Description"
                                dataItemKey="_id"
                                onChange={onChange}
                                value={dataItem.Aggregator}
                            />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <div className="col-12 col-md-6 d-flex flex-wrap align-items-end gap-3">
                            <div className="flex-grow-1 mr-2">
                                <label className="form-label">{lang.valid_from_label} *</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    name="ValidFrom"
                                    value={dataItem.ValidFrom}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="flex-grow-1 mr-2">
                                <label className="form-label">{lang.valid_to_label} *</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    name="ValidTo"
                                    value={dataItem.ValidTo}
                                    onChange={onChange}
                                    disabled={dataItem.TBA}
                                />
                            </div>
                            <div className="d-flex align-items-center mt-3">
                                <input
                                    type="checkbox"
                                    name="TBA"
                                    checked={dataItem.TBA}
                                    onChange={onChange}
                                    className="me-2"
                                />
                                <label className="form-label mb-0 m-1">{lang.tba_label}</label>
                            </div>
                        </div>
                        <div className='col-6'>
                            <label>{lang.access_key_label} *</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={accessKey}
                                    disabled
                                />
                                <div className="input-group-append">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-secondary"
                                        onClick={generateAccessKey}
                                        style={{ height: "31px" }}
                                    >
                                        {"Generate"}
                                    </button>
                                    {accessKey && (
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={copyToClipboard}
                                            style={{ height: "31px" }}
                                        >
                                            {"Copy"}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <div className='col-6'>
                            <label>{lang.content_distribution_api_label}</label>
                            <MyMultiSelect
                                style={{ backgroundColor: "white" }}
                                className="form-control form-control-sm"
                                data={contentDistributionApis}
                                name="ContentDistributionApiIds"
                                textField="Description"
                                dataItemKey="_id"
                                onChange={onChange}
                                value={dataItem.ContentDistributionApiIds}
                            />
                        </div>
                        <div className='col-6'>
                            <label>{lang.content_distribution_response_type_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={responseTypes}
                                name='ResponseType'
                                textField='Description'
                                dataItemKey='_id'
                                className='form-control form-control-sm'
                                value={dataItem.ResponseType}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "10px" }}>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={tabNumber}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                        <Tab label={lang.assets_label} value="1" />
                                        <Tab label={lang.distribution_label} value="2" />
                                        <Tab label={lang.delivery_label} value="3" />
                                    </TabList>
                                </Box>
                                <TabPanel value={"1"} style={{ padding: '10px' }}>
                                    <div className="row">
                                        <div className="col-12">
                                            <OttAssetCollection module={MODULE.OTT_ASSETS} entityname={ENTITYNAME.OttAsset}
                                                title={lang.assets_page_breadcrumb} customEditForm={OttEditForm} page_take={100} filterable={false}
                                                showFilterTemplate={true} showTitle={false} showBack={false} gridstyle={{ height: "37vh" }} />
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={"2"} style={{ padding: '10px' }}>
                                    <div className="row" style={{ maxHeight: "42vh", overflowY: "auto" }}>
                                        <div className="col-12">
                                            <ContentDistributionForm
                                                item={dataItem?.Distribution ? { ...dataItem, ...dataItem.Distribution } : dataItem}
                                                setItem={(updatedDistribution) => setDataItem({ ...dataItem, Distribution: updatedDistribution })}
                                                contentDistributionApis={contentDistributionApis}
                                                AccessKey={accessKey}
                                            />
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={"3"} style={{ padding: '10px' }}>
                                    <div className="row" style={{ maxHeight: "42vh", overflowY: "auto" }}>
                                        <div className='col-12'>
                                            <ContentDistributionDeliveryForm item={deliveryDataItem} setItem={setDeliveryDataItem} />
                                        </div>
                                    </div>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </div>
                </div>
            </div>

        </BossDialog>
    );
};

export default ContentDistributionEditForm